import React, { useState, useEffect, ReactNode } from 'react';
import { Alert } from 'reactstrap';

interface FloatingDismissibleAlertProps {
    children: ReactNode;
    color?: 'danger' | 'info' | 'warning' | 'success';
    clearError: () => void;
}

const FloatingDismissibleAlert = ({ children, clearError, color = 'danger' }: FloatingDismissibleAlertProps) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (children) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    }, [children]);

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1050, padding: '10px' }}>
            <Alert color={color} isOpen={visible} toggle={clearError} fade>
                <span style={{ userSelect: 'none', caretColor: 'transparent' }}>{children}</span>
            </Alert>
        </div>
    );
};

export default FloatingDismissibleAlert;